document.addEventListener('DOMContentLoaded', function () {
    function pdpStrings() {
        return window.pdpFormStrings || {};
    }

    // Main Slider
    const productContent = document.getElementById('pdp-product-content');
    const mediaGallery = document.getElementById('media-gallery');
    const toggleMediaGallery = document.querySelectorAll('.js-toggle-media-gallery');
    const slider = document.getElementById('product-media__slider');
    const sliderContainer = slider.querySelector('.product-media__slides');
    const slides = slider.querySelectorAll('.product-media__slide');
    const thumbContainer = document.querySelector('.product-media__thumbs-content');
    const thumbs = document.querySelectorAll('.product-media__thumb');
    const prevButtons = document.querySelectorAll('.product-media__prev');
    const nextButtons = document.querySelectorAll('.product-media__next');
    const counter = document.querySelector('.product-media__counter'); // Counter element

    let currentSlide = 0;
    const totalSlides = slides.length;
    let isDragging = false;
    let startX, currentTranslate, prevTranslate, animationID;
    let currentIndex = 0;

    // Helper function to get current total slides (filtered or original)
    function getTotalSlides() {
        return window.totalSlidesFiltered || totalSlides;
    }

    // Drag functionality
    function startDrag(e) {
        isDragging = true;
        startX = e.pageX || e.touches[0].pageX;
        prevTranslate = currentTranslate || 0;
        animationID = requestAnimationFrame(animation);
        slider.classList.add('dragging');
    }

    function stopDrag() {
        isDragging = false;
        cancelAnimationFrame(animationID);
        slider.classList.remove('dragging');

        // Snap to the closest slide
        const movedBy = currentTranslate - prevTranslate;
        if (movedBy < -100 && currentIndex < getTotalSlides() - 1) currentIndex += 1;
        if (movedBy > 100 && currentIndex > 0) currentIndex -= 1;

        goToSlide(currentIndex);
    }

    function dragMove(e) {
        if (!isDragging) return;
        const currentPosition = e.pageX || e.touches[0].pageX;
        const delta = currentPosition - startX;
        currentTranslate = prevTranslate + delta;
    }

    function animation() {
        if (isDragging) {
            sliderContainer.style.transform = `translateX(${currentTranslate}px)`;
            requestAnimationFrame(animation);
        }
    }

    // Updated goToSlide function
    function goToSlide(index, animate = true) {
        currentIndex = index;
        currentSlide = index;
        
        // Get visible slides only
        const visibleSlides = Array.from(slides).filter(slide => slide.style.display !== 'none');
        
        if (visibleSlides.length === 0) return;
        
        // Get the target visible slide
        const targetSlide = visibleSlides[index];
        if (!targetSlide) return;
        
        // Calculate offset based on the actual position of the target slide
        const slideWidth = targetSlide.getBoundingClientRect().width;
        const offset = -index * slideWidth;
        currentTranslate = offset;
        prevTranslate = offset;

        if (!animate) {
            sliderContainer.style.transition = 'none';
        } else {
            sliderContainer.style.transition = 'transform 0.5s ease';
        }

        sliderContainer.style.transform = `translateX(${offset}px)`;
        updateThumbs(index);
        updateCounter(index + 1); // Update the counter, converting to a 1-based index

        if (!animate) {
            setTimeout(() => {
                sliderContainer.style.transition = 'transform 0.5s ease';
            }, 50);
        }

        updateArrowOpacity();
    }

    function updateThumbs(index) {
        // Get visible thumbs only
        const visibleThumbs = Array.from(thumbs).filter(thumb => thumb.style.display !== 'none');
        
        if (visibleThumbs.length === 0) return;
        
        // Remove active class from all visible thumbs
        visibleThumbs.forEach((thumb, i) => {
            thumb.classList.toggle('active', i === index);
        });
        
        if (!thumbContainer || visibleThumbs.length === 0) return;
        
        const containerOffset = thumbContainer.parentElement.offsetHeight / 2;
        const thumbHeight = visibleThumbs[0].offsetHeight + 8;

        // Adjust the thumb container to bring the active thumb to the first position
        const thumbOffset = index < 3 ? 0 : ((thumbHeight * index) - containerOffset) + (thumbHeight / 2);
        thumbContainer.style.transform = `translateY(-${thumbOffset}px)`;
    }

    // Function to update the counter
    function updateCounter(currentSlide) {
        if (!counter) return;
        counter.textContent = `${currentSlide} / ${getTotalSlides()}`;
    }

    prevButtons.forEach(button => {
        button.addEventListener('click', function () {
            const newSlide = (currentSlide - 1 + getTotalSlides()) % getTotalSlides();
            goToSlide(newSlide);
        });
    });

    nextButtons.forEach(button => {
        button.addEventListener('click', function () {
            const newSlide = (currentSlide + 1) % getTotalSlides();
            goToSlide(newSlide);
        });
    });

    function updateArrowOpacity() {
        const atStart = currentSlide === 0;
        const atEnd = currentSlide === getTotalSlides() - 1;

        prevButtons.forEach(button => button.disabled = atStart);
        nextButtons.forEach(button => button.disabled = atEnd);
    }

    // Main Form
    // Get an array with options of clicked variant (ie value: 'Black', index: 'option1')
    function getVariantFromSwatches() {
        const variantArr = [];
        document.querySelectorAll('.product-option input[type=radio]').forEach((el) => {
            if (el.checked) {
                variantArr.push({
                    value: el.value,
                    index: el.getAttribute('data-index')
                });
            }
        });
        return variantArr;
    }

    // Update URL
    function updateHistoryState(variant) {
        if (!history.replaceState || !variant) return;

        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant.id}`;

        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    // Money Format
    const theme = {
        Currency: (function () {
            const moneyFormat = "${{amount}}";

            function formatMoney(cents, format) {
                if (typeof cents === "string") {
                    cents = cents.replace(".", "");
                }
                const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                const formatString = format || moneyFormat;

                function formatWithDelimiters(number, precision, thousands, decimal) {
                    thousands = thousands || ",";

                    if (isNaN(number) || number === null) return 0;

                    number = (number / 100.0).toFixed(precision);

                    const parts = number.split(".");
                    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);

                    return dollarsAmount;
                }

                let value = "";
                switch (formatString.match(placeholderRegex)[1]) {
                    case "amount":
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case "amount_no_decimals":
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case "amount_with_comma_separator":
                        value = formatWithDelimiters(cents, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        value = formatWithDelimiters(cents, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        value = formatWithDelimiters(cents, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        value = formatWithDelimiters(cents, 2, "'");
                        break;
                }

                return formatString.replace(placeholderRegex, value);
            }

            return { formatMoney: formatMoney };
        })()
    };

    // Change class for swatch
    document.querySelectorAll('.swatch').forEach((swatch) => {
        swatch.addEventListener('click', () => {
            const optionsWrap = swatch.closest('.options_wrap');
            optionsWrap.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
        });
    });

    function update_variant_id(variant) {
        document.getElementById('variant_id').value = variant;
    }

    function update_slider_image(variantImg) {
        const slideIndex = parseInt(document.getElementById(variantImg).getAttribute('slide-index'));
        goToSlide(slideIndex);
    }

    function updateVariantGallery(variantId) {
        const mediaContainer = document.querySelector('.product-media');
        if (!mediaContainer || !mediaContainer.dataset.variantGalleryMap) return;

        try {
            const variantGalleryMap = JSON.parse(mediaContainer.dataset.variantGalleryMap);
            const variantImages = variantGalleryMap[variantId];

            if (!variantImages || variantImages.length === 0) {
                // If no variant-specific images, show all images and remove opacity
                slides.forEach(slide => {
                    slide.style.display = 'block';
                });
                thumbs.forEach(thumb => {
                    thumb.style.display = 'block';
                });
                return;
            }

            // Hide all slides and thumbs first
            slides.forEach(slide => {
                slide.style.display = 'none';
            });
            thumbs.forEach(thumb => {
                thumb.style.display = 'none';
            });

            // Show only slides that match variant images
            let visibleSlideIndex = 0;
            slides.forEach((slide, index) => {
                const slideImg = slide.querySelector('img');
                if (slideImg && variantImages.some(variantImg => slideImg.src.includes(variantImg) || variantImg.includes(slideImg.src))) {
                    slide.style.display = 'block';
                    if (thumbs[index]) {
                        thumbs[index].style.display = 'block';
                        thumbs[index].dataset.index = visibleSlideIndex;
                    }
                    slide.setAttribute('slide-index', visibleSlideIndex);
                    visibleSlideIndex++;
                }
            });

            // Update total slides count for navigation
            const visibleSlides = Array.from(slides).filter(slide => slide.style.display !== 'none');
            window.totalSlidesFiltered = visibleSlides.length;

            // Fallback: If no visible images, show all images
            if (visibleSlides.length === 0) {
                slides.forEach(slide => {
                    slide.style.display = 'block';
                });
                thumbs.forEach(thumb => {
                    thumb.style.display = 'block';
                });
                window.totalSlidesFiltered = totalSlides;
                
                // Update counter with new total
                if (counter) {
                    counter.textContent = `1 / ${totalSlides}`;
                }

                // Reset to first slide
                currentIndex = 0;
                goToSlide(0, false);
                updateArrowOpacity();
                
                // Remove opacity-0 class from media gallery if present
                if (mediaGallery.classList.contains('opacity-0')) {
                    mediaGallery.classList.add('transition-opacity', 'duration-300');
                    setTimeout(() => {
                        mediaGallery.classList.remove('opacity-0');
                    }, 50);
                }
                return;
            }

            // Update counter with new total
            if (counter) {
                counter.textContent = `1 / ${window.totalSlidesFiltered}`;
            }

            // Reset to first visible slide
            currentIndex = 0;
            goToSlide(0, false);
            updateArrowOpacity();

            // Remove opacity-0 class from media gallery with transition for smooth fade-in
            if (mediaGallery.classList.contains('opacity-0')) {
                mediaGallery.classList.add('transition-opacity', 'duration-300');
                setTimeout(() => {
                    mediaGallery.classList.remove('opacity-0');
                }, 50);
            }
        } catch (e) {
            console.error('Error updating variant gallery:', e);
        }
    }

    function savingsPlaceholderValue(display, comparePrice, regularPrice) {
        if (!comparePrice || comparePrice <= regularPrice) return '';
        const save = comparePrice - regularPrice;
        const money = theme.Currency.formatMoney(save, theme.moneyFormat);
        const pct = Math.round((100 * save) / comparePrice);
        if (display === 'money') return money;
        if (display === 'percentage') return `${pct}%`;
        if (display === 'both') return `${money} (${pct}%)`;
        return '';
    }

    function updateProductSavingsLine(variant) {
        const container = document.getElementById('product_price_container');
        const line = document.getElementById('product_savings_line');
        if (!container || !line) return;

        const display = container.dataset.savingsDisplay;
        const template = container.dataset.savingsTemplate || '';
        if (!display || display === 'none' || !template) {
            line.textContent = '';
            line.classList.add('hidden');
            return;
        }

        const comparePrice = variant.compare_at_price;
        const regularPrice = variant.price;
        const x = savingsPlaceholderValue(display, comparePrice, regularPrice);
        if (!x) {
            line.textContent = '';
            line.classList.add('hidden');
            return;
        }

        line.textContent = template.split('{discount}').join(x);
        line.classList.remove('hidden');
    }

    function update_product_price(variant) {
        const regular_price = variant.price;
        const compare_price = variant.compare_at_price;

        let output = '';
        let stickyOutput = '';
        if (compare_price === 0 || compare_price === undefined) {
            const regular_price_output = `<span class="money regular_price" id="regular_price" data-variant-id="${variant.id}">${theme.Currency.formatMoney(regular_price, theme.moneyFormat)}</span>`;
            output += regular_price_output;
            stickyOutput += regular_price_output;
        } else {
            if (compare_price > regular_price) {
                const compare_price_output = `<span class="money compare_price" id="compare_price" data-variant-id="${variant.id}"> <del>${theme.Currency.formatMoney(compare_price, theme.moneyFormat)}</del></span>`;
                output += compare_price_output;
            }
            const regular_price_output = `<span class="money regular_price" id="regular_price" data-variant-id="${variant.id}" data-product-id="${variant.product_id}">${theme.Currency.formatMoney(regular_price, theme.moneyFormat)}</span>`;
            output += regular_price_output;
            stickyOutput += regular_price_output;
        }
        const productPriceEl = document.getElementById('product_price');
        if (productPriceEl) {
            productPriceEl.innerHTML = output;
        }
        const stickyPrice = document.getElementById('sticky_product_price');
        if (stickyPrice) {
            stickyPrice.innerHTML = stickyOutput;
        }
        updateProductSavingsLine(variant);
    }

    function update_add_to_cart_text(variant) {
        const addToCart = document.getElementById('addToCart');
        const klaviyoOOS = document.getElementById('klaviyoOOS');
        if (!variant.available)  {
            if (addToCart) addToCart.style.display = 'none';
            klaviyoOOS.classList.remove('hidden');
        } else {
            if (addToCart)  {
                addToCart.style.display = 'block';
                addToCart.removeAttribute('disabled');
                const cartLabel = pdpStrings().addToCartLabel || 'Add to cart';
                addToCart.textContent = `${cartLabel} - ${theme.Currency.formatMoney(variant.price, theme.moneyFormat)}`;
            }
            klaviyoOOS.classList.add('hidden');
        }
        if (variant.inventory === 0 && variant.continue === 'continue') {
            if (addToCart) {
                addToCart.style.display = 'block';
                addToCart.removeAttribute('disabled');
                const preOrderButtonLabel = variant.pre_order_notice_button_text || pdpStrings().preOrderButtonLabel || 'Pre order';
                addToCart.textContent = preOrderButtonLabel;
            }
            klaviyoOOS.classList.add('hidden');
        }
    }

    function update_inventory_label(variant) {
        const inventoryLabel = document.getElementById('inventoryLabel');
        if (variant.inventory < 10 && variant.inventory > 0) {
            inventoryLabel.style.display = 'flex';
        } else {
            inventoryLabel.style.display = 'none';
        }
    }

    function toggleNoStockContent(variant) {
        if (productContent) {
            let stockState = 'in';
            if (variant.inventory === 0 && variant.continue === 'continue') {
                stockState = 'preorder';
            } else if (!variant.available) {
                stockState = 'out';
            }
            productContent.setAttribute('data-instock', stockState);
        }
    }

    function update_oos_label(variant) {
        const inventoryOOSLabel = document.getElementById('inventoryOOSLabel');
        if (variant.inventory === 0) {
            inventoryOOSLabel.style.display = 'flex';
        } else {
            inventoryOOSLabel.style.display = 'none';
        }
    }

    function update_pre_order_label(variant) {
        const preOrderLabel = document.getElementById('preOrderLabel');
        const inventoryOOSLabel = document.getElementById('inventoryOOSLabel');
        const preOrderPropertyInput = document.getElementById('preOrderPropertyInput');
        if (!preOrderLabel) return;
        const headingEl = document.getElementById('preOrderLabelHeading');
        const bodyEl = document.getElementById('preOrderLabelBody');
        const s = pdpStrings();
        const h = s.preOrderHeading != null ? String(s.preOrderHeading).trim() : '';
        const b = variant.pre_order_notice_body != null ? String(variant.pre_order_notice_body).trim() : '';
        if (variant.inventory === 0 && variant.continue === 'continue') {
            if (headingEl) {
                headingEl.textContent = h;
                headingEl.classList.toggle('hidden', !h);
            }
            if (bodyEl) {
                bodyEl.textContent = b;
                bodyEl.classList.toggle('hidden', !b);
            }
            if (inventoryOOSLabel) inventoryOOSLabel.style.display = 'none';
            preOrderLabel.style.display = 'flex';
            if (preOrderPropertyInput) preOrderPropertyInput.disabled = false;
            
        } else {
            preOrderLabel.style.display = 'none';
            if (preOrderPropertyInput) preOrderPropertyInput.disabled = true;
        }
    }

    function updateMasterVariant(variant) {
        const masterSelect = document.querySelector('.pair_variant_select');
        masterSelect.value = variant.id;
        const stickyId = document.getElementById('stickyId');
        stickyId.value = variant.id;
    }

    function update_delivery_time(variant) {
        const deliveryTimeEl = document.getElementById('deliveryTime');
        if (!deliveryTimeEl) return;
        
        // Default delivery days (matching theme settings defaults)
        const minDays = 10;
        const maxDays = 14;
        
        // Add 2 weeks (14 days) for preorder
        let extraDays = 0;
        if (variant.inventory === 0 && variant.continue === 'continue') {
            extraDays = 14;
        }
        
        const minDate = new Date();
        minDate.setDate(minDate.getDate() + minDays + extraDays);
        
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + maxDays + extraDays);
        
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        deliveryTimeEl.textContent = `${minDate.toLocaleDateString('en-US', options)} - ${maxDate.toLocaleDateString('en-US', options)}`;
    }

    function updateTitle(variant) {
        document.querySelectorAll('.variantTitle').forEach(element => {
            const index = element.getAttribute('data-index');
            const [firstPart, secondPart] = variant.title.split('/').map(part => part.trim());

            if (index === '1') {
                element.textContent = firstPart;
            } else if (index === '2') {
                element.textContent = secondPart;
            }
        });
        document.getElementById('stickyVariantTitle').textContent = variant.title;
    }


    // On change main
    document.querySelectorAll('input[type=radio]').forEach((radio) => {
        const selectedValues = getVariantFromSwatches();
        if (!window.product || !window.product.variants) {
            return;
        }
        const variants = window.product.variants;
        let found = null;

        variants.forEach(variant => {
            let satisfied = true;
            selectedValues.forEach(option => {
                if (satisfied) {
                    satisfied = option.value === variant[option.index];
                }
            });
            if (satisfied) {
                found = variant;
            }
        });

        if (found) {
            update_add_to_cart_text(found);
            update_variant_id(found.id);
            updateVariantGallery(found.id);
            // update_slider_image(found.featured_image);
            updateMasterVariant(found);
            updateHistoryState(found);
            update_product_price(found);
            updateTitle(found);
            update_inventory_label(found);
            toggleNoStockContent(found);
            update_oos_label(found);
            update_pre_order_label(found);
            update_delivery_time(found);
        }
        
        radio.addEventListener('change', () => {
            const selectedValues = getVariantFromSwatches();
            const variants = window.product.variants;
            let found = null;

            variants.forEach(variant => {
                let satisfied = true;
                selectedValues.forEach(option => {
                    if (satisfied) {
                        satisfied = option.value === variant[option.index];
                    }
                });
                if (satisfied) {
                    found = variant;
                }
            });

            if (found) {
                update_add_to_cart_text(found);
                update_variant_id(found.id);
                updateVariantGallery(found.id);
                // update_slider_image(found.featured_image);
                updateMasterVariant(found);
                updateHistoryState(found);
                update_product_price(found);
                updateTitle(found);
                update_inventory_label(found);
                toggleNoStockContent(found);
                update_oos_label(found);
                update_pre_order_label(found);
                update_delivery_time(found);
            }
        });
    });
    
    // Initialize thumbs, arrows, and counter
    updateThumbs(0);
    updateCounter(1); // Set the counter to the first slide on load
    updateArrowOpacity();

    // Add click event listeners to thumbs
    thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
            e.preventDefault();
            // Use the data-index attribute which is set correctly for visible slides
            const slideIndex = parseInt(thumb.dataset.index) || 0;
            goToSlide(slideIndex);
        });
    });

    // Event listeners for drag functionality
    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('touchstart', startDrag);
    slider.addEventListener('mousemove', dragMove);
    slider.addEventListener('touchmove', dragMove);
    slider.addEventListener('mouseleave', stopDrag);
    slider.addEventListener('mouseup', stopDrag);
    slider.addEventListener('touchend', stopDrag);

    // Prevent default behavior when dragging (to avoid text selection)
    slider.addEventListener('dragstart', (e) => e.preventDefault());
    
    toggleMediaGallery.forEach(button => {
        button.addEventListener('click', function () {
            const isOpen = mediaGallery.getAttribute('data-fullscreen') === "true";
            console.log(isOpen);
            mediaGallery.setAttribute('data-fullscreen', String(!isOpen));
        });
    });

    const yotpoRatingWidget = document.querySelector('#yotpo-reviews-main-widget');
    const yotoReviewsWidget = document.querySelector('.product-content__rating');
    if (yotpoRatingWidget && yotoReviewsWidget) {
        yotoReviewsWidget.addEventListener('click', function() {
            yotpoRatingWidget.scrollIntoView({
                behavior: 'smooth'
            });
        });   
    }
});
